import { Employee } from '@/types/resources/employee';
import dayjs from 'dayjs';

const WORKSPACE_ID = 'sunset-apartments';
const createWorkspaceRef = () => ({
  id: WORKSPACE_ID,
  name: 'Apartamentos Sunset',
  slug: 'sunset-apartments',
});

const departments = ['Manutenção', 'Segurança', 'Administração', 'Limpeza', 'Gestão'];
const roles = ['manager', 'maintenance', 'security', 'admin', 'other'];

const celebrityNames = [
  'Dwayne Johnson', 'Chris Hemsworth', 'Robert Downey Jr.', 'Akshay Kumar', 'Jackie Chan',
  'Will Smith', 'Adam Sandler', 'Shah Rukh Khan', 'Salman Khan', 'Amitabh Bachchan',
  'Vin Diesel', 'Tom Cruise', 'Mark Wahlberg', 'Ryan Reynolds', 'Chris Evans',
  'Jennifer Lopez', 'Scarlett Johansson', 'Sofia Vergara', 'Kaley Cuoco', 'Reese Witherspoon',
  'Angelina Jolie', 'Gal Gadot', 'Julia Roberts', 'Mila Kunis', 'Emma Watson',
  'Charlize Theron', 'Amy Adams', 'Kristen Stewart', 'Emma Stone', 'Jennifer Aniston',
  'Leonardo DiCaprio', 'George Clooney', 'Johnny Depp', 'Ben Affleck', 'Hugh Jackman',
  'Sandra Bullock', 'Nicole Kidman', 'Melissa McCarthy', 'Cate Blanchett', 'Meryl Streep',
  'Denzel Washington', 'Matt Damon', 'Bradley Cooper', 'Christian Bale', 'Idris Elba',
  'Viola Davis', 'Octavia Spencer', 'Taraji P. Henson', 'Regina King', 'Kerry Washington'
];

export const employees: Employee[] = Array.from({ length: 50 }, (_, idx) => {
  const name = celebrityNames[idx % celebrityNames.length];
  const department = departments[idx % departments.length];
  const role = roles[idx % roles.length];
  
  return {
    id: `EMP-${(idx + 1).toString().padStart(3, '0')}`,
    employeeId: `EID-${(idx + 1).toString().padStart(4, '0')}`,
    role: role as Employee['role'],
    status: idx % 10 === 0 ? 'inactive' : 'active',
    department: department,
    shiftTiming: [], // Can be expanded later
    joiningDate: dayjs().subtract(Math.floor(Math.random() * 5 * 365), 'days').toDate(),
    exitDate: idx % 10 === 0 ? dayjs().subtract(Math.floor(Math.random() * 30), 'days').toDate() : undefined,
    salary: { amount: 45000 + Math.floor(Math.random() * 50000), currency: 'BRL' },
    contacts: [{ name: `${name} (Pessoal)`, phone: `+55-11-${idx.toString().padStart(4, '0')}-${(idx + 1000).toString().padStart(4, '0')}` }],
    user: {
      id: `user-emp-${idx + 1}`,
      displayName: name,
      email: `${name.toLowerCase().replace(/ /g, '.')}@demo.com`,
      phoneNumber: `+55-11-${idx.toString().padStart(4, '0')}-${(idx + 1000).toString().padStart(4, '0')}`,
    },
    workspace: createWorkspaceRef(),
    activityRecords: [{
      timestamp: dayjs().subtract(Math.floor(Math.random() * 30), 'days').toDate(),
      type: 'created',
      performedBy: { id: 'admin-001', displayName: 'Gerente de Propriedade' }
    }]
  };
});